export const TITULO_DIALOG_EXLUSAO = "Excluir usuário";

export const TEXTO_DIALOG_EXLUSAO =
  "Ao excluir este usuário (<nome>), o login e o e-mail associados a ele não poderão ser utilizados para criar novas contas no sistema.";
